import {
  QuantityBox,
  QuantityButton,
  Count
} from './QuantityButtons.styled';
import { RiAddFill, RiSubtractFill } from 'react-icons/ri'

const QuantityButtons = ({
  quantity,
  onClickAdd,
  onClickSubtract
}) => {
  return (
    <QuantityBox>
      <QuantityButton onClick={onClickSubtract}>
        <RiSubtractFill size={16} />
      </QuantityButton>
      <Count>{quantity}</Count>
      <QuantityButton onClick={onClickAdd}>
        <RiAddFill size={16} />
      </QuantityButton>
    </QuantityBox>
  )
}

export default QuantityButtons;